/* global modForm */
/**
 * This function maps the dynamic service code value based on selected form data
 * @param {String} formData - form data
 * @returns {String} - dynamic service code value
 */
export function mapDynamicServiceCode(formData) {
	let dynamicServiceCode = '';

	const serviceCodeMapping = {
		'BATHROOM_REFACING': 'BathProjectScope',
		'CABINET_REFACING': 'service',
		'CONCRETE_FOUNDATION': 'service',
		'FLOORING_HARDWOOD': 'ProductService',
		'PLUMBING': 'ServiceDetails',
		'ROOFING_ASPHALT': 'ProductService',
		'SIDING_VINYL': 'ProductService',
		'WALK_IN_TUBS': 'ProductService',
		'FENCING': 'ProductService'
	};

	const service = modForm.opts.vertical;
	const formProperty = serviceCodeMapping[service];

	if (service === 'BATHROOM_REFACING' && formData.BathProjectScope) {
		dynamicServiceCode = formData.BathProjectScope === 'Bathroom Remodel' ? 'BATH_REMODEL' : 'BATHROOM_REFACING';
		// Angi does not buy remodeling leads WITHOUT doing wall removal - so mapping this to back to REFACING if "No Wall Removal"
		if (modForm.opts.optInAddRemoveWalls && formData.OptIn1 === 'No') {
			dynamicServiceCode = 'BATHROOM_REFACING';
		}
	} else if (formProperty && formData[formProperty]) {
		dynamicServiceCode = formData[formProperty];
	} else {
		dynamicServiceCode = service;
	}

	return dynamicServiceCode;
}
